"use strict";
// Copyright (C) 2017-2024 Smart code 203358507
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var classnames_1 = __importDefault(require("classnames"));
var components_1 = require("stremio/components");
var core_1 = require("stremio/core");
var useProfile_1 = __importDefault(require("stremio/common/useProfile"));
var CoreSuspender_1 = require("stremio/common/CoreSuspender");
var StreamingServerWarning_less_1 = __importDefault(require("./StreamingServerWarning.less"));
var StreamingServerWarning = function (_a) {
    var className = _a.className;
    var t = (0, react_i18next_1.useTranslation)().t;
    var core = (0, core_1.useCore)();
    var profile = (0, useProfile_1.default)();
    var createDismissalDate = function (months, years) {
        if (years === void 0) { years = 0; }
        var dismissalDate = new Date();
        if (months) {
            dismissalDate.setMonth(dismissalDate.getMonth() + months);
        }
        if (years) {
            dismissalDate.setFullYear(dismissalDate.getFullYear() + years);
        }
        return dismissalDate;
    };
    var updateSettings = (0, react_1.useCallback)(function (streamingServerWarningDismissed) {
        core.transport.dispatch({
            action: 'Ctx',
            args: {
                action: 'UpdateSettings',
                args: __assign(__assign({}, profile.settings), { streamingServerWarningDismissed: streamingServerWarningDismissed })
            }
        });
    }, [profile.settings]);
    var onLater = (0, react_1.useCallback)(function () {
        updateSettings(createDismissalDate(1));
    }, [updateSettings]);
    var onDismiss = (0, react_1.useCallback)(function () {
        updateSettings(createDismissalDate(0, 50));
    }, [updateSettings]);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(className, StreamingServerWarning_less_1.default['warning-container']) },
        react_1.default.createElement("div", { className: StreamingServerWarning_less_1.default['warning-statement'] }, "Stremio Service is unavailable. Compatible direct streams can still play here. Torrents and some formats need the service."),
        react_1.default.createElement("div", { className: StreamingServerWarning_less_1.default['actions'] },
            react_1.default.createElement("a", { href: 'https://www.stremio.com/download-service', target: '_blank', rel: 'noreferrer' },
                react_1.default.createElement(components_1.Button, { className: StreamingServerWarning_less_1.default['action'], title: t('SERVICE_INSTALL'), tabIndex: -1 },
                    react_1.default.createElement("div", { className: StreamingServerWarning_less_1.default['label'] }, t('SERVICE_INSTALL')))),
            react_1.default.createElement(components_1.Button, { className: StreamingServerWarning_less_1.default['action'], title: t('WARNING_STREAMING_SERVER_LATER'), onClick: onLater, tabIndex: -1 },
                react_1.default.createElement("div", { className: StreamingServerWarning_less_1.default['label'] }, t('WARNING_STREAMING_SERVER_LATER'))),
            react_1.default.createElement(components_1.Button, { className: StreamingServerWarning_less_1.default['action'], title: t('DONT_SHOW_AGAIN'), onClick: onDismiss, tabIndex: -1 },
                react_1.default.createElement("div", { className: StreamingServerWarning_less_1.default['label'] }, t('DONT_SHOW_AGAIN'))))));
};
exports.default = (0, CoreSuspender_1.withCoreSuspender)(StreamingServerWarning);
